import { render, staticRenderFns } from "./UserubgroupUsers.vue?vue&type=template&id=3530172f"
import script from "./UserubgroupUsers.vue?vue&type=script&lang=js"
export * from "./UserubgroupUsers.vue?vue&type=script&lang=js"
import style0 from "./UserubgroupUsers.vue?vue&type=style&index=0&id=3530172f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports